import moment from 'moment'
import { DATE } from '@const'

/**
 * get current time UTC uxix with utcOffset
 * if you wannat get UTC -4, please put 4 * 60 as utcOffset
 * if you wannat get UTC +8, please put -8 * 60 as utcOffset
 */
export function getCurrentUnix(utcOffset) {
    const clientOffset = new Date().getTimezoneOffset()
    return moment()
        .utcOffset(utcOffset - clientOffset, true)
        .unix()
}

export function getCurrentUTCMoment() {
    return moment().utc()
}

export function getMoment(datetime) {
    return moment(datetime)
}

/**
 * CMS datetime to UTC unix
 */
export function datetimeToUnix(datetime) {
    return moment(datetime, DATE.MOMENT_PARSE_FORMAT).utcOffset(DATE.CLIENT_UTC_OFFSET, true).unix()
}

/**
 * CMS datetime to start of unit UTC unix
 */
export function datetimeToUnix_startOf(datetime, unit) {
    return moment(datetime, DATE.MOMENT_PARSE_FORMAT).utcOffset(DATE.CLIENT_UTC_OFFSET, true).startOf(unit).unix()
}

/**
 * CMS datetime to end of unit UTC unix
 */
export function datetimeToUnix_endOf(datetime, unit) {
    return moment(datetime, DATE.MOMENT_PARSE_FORMAT).utcOffset(DATE.CLIENT_UTC_OFFSET, true).endOf(unit).unix()
}

export function datetimeStartOfWithoutOffset(datetime, unit) {
    return moment(datetime, DATE.MOMENT_PARSE_FORMAT).startOf(unit)
}

export function datetimeEndOfWithoutOffset(datetime, unit) {
    return moment(datetime, DATE.MOMENT_PARSE_FORMAT).endOf(unit)
}

export function momentToUTCString(m) {
    return moment(m).subtract(DATE.CLIENT_UTC_OFFSET, 'hours').format('YYYY-MM-DD HH:mm:ss')
}

/**
 * UTC unix to CMS datetime format with Millisecord YYYY/MM/DD HH:mm:ss.SSS
 */
export function unixToDateTimeMS(timestamp) {
    if (!Number.isInteger(timestamp)) {
        timestamp = Date.parse(timestamp) / 1000
    }
    return moment.unix(timestamp).utcOffset(DATE.CLIENT_UTC_OFFSET).format('YYYY/MM/DD HH:mm:ss.SSS')
}

/**
 * UTC unix to CMS datetime format YYYY/MM/DD HH:mm:ss
 */
export function unixToDateTime(timestamp) {
    if (!timestamp) return ''

    if (!Number.isInteger(timestamp)) {
        timestamp = Date.parse(timestamp) / 1000
    }
    return moment.unix(timestamp).utcOffset(DATE.CLIENT_UTC_OFFSET).format('YYYY/MM/DD HH:mm:ss')
}

export function unixToOffsetDateTime(timestamp, { count, type }) {
    if (!timestamp) return ''

    if (!Number.isInteger(timestamp)) {
        timestamp = Date.parse(timestamp) / 1000
    }
    return moment.unix(timestamp).utcOffset(DATE.CLIENT_UTC_OFFSET).add(count, type).format('YYYY/MM/DD HH:mm:ss')
}

/**
 * UTC unix to CMS date format YYYY/MM/DD
 */
export function unixToDate(timestamp) {
    if (!Number.isInteger(timestamp)) {
        timestamp = Date.parse(timestamp) / 1000
    }
    return moment.unix(timestamp).utcOffset(DATE.CLIENT_UTC_OFFSET).format('YYYY/MM/DD')
}

/**
 * UTC unix to CMS time format HH:mm:ss
 */
export function unixToTime(timestamp) {
    if (!Number.isInteger(timestamp)) {
        timestamp = Date.parse(timestamp) / 1000
    }
    return moment.unix(timestamp).utcOffset(DATE.CLIENT_UTC_OFFSET).format('HH:mm:ss')
}

/**
 * UTC unix to CMS month format YYYY/MM
 */
export function unixToDateMonth(timestamp) {
    if (!Number.isInteger(timestamp)) {
        timestamp = Date.parse(timestamp) / 1000
    }
    return moment.unix(timestamp).utcOffset(DATE.CLIENT_UTC_OFFSET).format('YYYY/MM')
}

/**
 * get CMS current datetime format YYYY/MM/DD HH:mm:ss
 */
export function currentDatetime() {
    return unixToDateTime(moment().unix())
}

/**
 * get added CMS datetime format YYYY/MM/DD HH:mm:ss
 */
export function datetimeAdd(datetime, interval, unit) {
    switch (unit) {
        case 'months':
        case 'M':
            unit = 'days'
            interval = interval * DATE.DAY_PER_MONTH + (interval > 0 ? -1 : 1)
            break
        default:
            break
    }
    return moment(datetime, DATE.MOMENT_PARSE_FORMAT).add(interval, unit).utcOffset(DATE.CLIENT_UTC_OFFSET, true).format('YYYY/MM/DD HH:mm:ss')
}

/**
 * get max datetme of inputs with currenct time
 */
export function getMaxDatetime(...datetime) {
    if (datetime.length <= 1) {
        datetime.push(currentDatetime())
    }
    return datetimeSort(...datetime)[datetime.length - 1]
}

/**
 * get min datetme of inputs with currenct time
 */
export function getMinDatetime(...datetime) {
    if (datetime.length <= 1) {
        datetime.push(currentDatetime())
    }
    return datetimeSort(...datetime)[0]
}

export function datetimeSort(...datetime) {
    datetime.forEach((val, idx) => {
        datetime[idx] = unixToDateTime(datetimeToUnix(val))
    })
    return datetime.sort()
}

export function isDateAfter(source, target) {
    return moment(source).isAfter(target)
}


export function getCurrentTimeByCurrency(currency = "CNY") {
    const currencyTimeZones = {
        "THB": "Asia/Bangkok",        // 泰铢 (Thai Baht)
        "CNY": "Asia/Shanghai",       // 人民币 (Chinese Yuan)
        "VND": "Asia/Ho_Chi_Minh",    // 越南盾 (Vietnamese Dong)
        "PHP": "Asia/Manila",         // 菲律宾比索 (Philippine Peso)
        "IDR": "Asia/Jakarta",        // 印尼盾 (Indonesian Rupiah)
        "INR": "Asia/Kolkata",        // 印度卢比 (Indian Rupee)
        "USD": "America/New_York",    // 美元 (US Dollar)
        "MYR": "Asia/Kuala_Lumpur",   // 马来西亚林吉特 (Malaysian Ringgit)
        "MYRH": "Asia/Kuala_Lumpur",  // 也是马来西亚林吉特
        "USDT": "America/New_York",   // 泰达币 (Tether, a stablecoin pegged to USD)
        "MMK": "Asia/Yangon",         // 缅元 (Myanmar Kyat)
        "HKD": "Asia/Hong_Kong",      // 港元 (Hong Kong Dollar)
        "NPR": "Asia/Kathmandu",      // 尼泊尔卢比 (Nepalese Rupee)
        "BDT": "Asia/Dhaka",          // 孟加拉塔卡 (Bangladeshi Taka)
        "MXN": "America/Mexico_City", // 墨西哥比索 (Mexican Peso)
        "TND": "Africa/Tunis",        // 突尼斯第纳尔 (Tunisian Dinar)
        "THBT": "Asia/Bangkok",       // 也是泰铢
        "MMKO": "Asia/Yangon",        // 也是缅元
        "VNDO": "Asia/Ho_Chi_Minh",   // 也是越南盾
        "TRY": "Europe/Istanbul",     // 土耳其里拉 (Turkish Lira)
        "BRL": "America/Sao_Paulo",   // 巴西雷亚尔 (Brazilian Real)
        "AUD": "Australia/Sydney",    // 澳大利亚元 (Australian Dollar)
        "KES": "Africa/Nairobi",      // 肯尼亚先令 (Kenyan Shilling)
        "NGN": "Africa/Lagos",        // 尼日利亚奈拉 (Nigerian Naira)
        "AMD": "Asia/Yerevan",        // 亚美尼亚德拉姆 (Armenian Dram)
        "PKR": "Asia/Karachi",        // 巴基斯坦卢比 (Pakistani Rupee)
        "ZAR": "Africa/Johannesburg", // 南非兰特 (South African Rand)
        "JPY": "Asia/Tokyo",          // 日元 (Japanese Yen)
        "KRW": "Asia/Seoul",          // 韩元 (South Korean Won)
        "TST": "UTC"                  // UTC 时间
    };

    const timeZone = currencyTimeZones[currency];
    if (!timeZone) {
        return ''; // 不支持的貨幣
    }

    const now = new Date();
    const options = {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    };

    const formatter = new Intl.DateTimeFormat('zh-CN', options);
    return formatter.format(now);
}
